export default {
  data () {
    return {
      reqId: 'integrations-list',
      connectReqId: 'integrations-connect-zoom'
    }
  },
  computed: {
    oauthUrl () {
      return 'https://api.appointmentguru.co/integrations/zoom/'
    },
    integration () {
      let lookups = this.$store.getters.lookups
      if ('integrations' in lookups) {
        return lookups.integrations.find((integration) => {
          return integration.title === 'Zoom'
        })
      }
      return null
    },
    integrationsRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    oAuthCode () {
      if (this.$route.query.code) {
        return this.$route.query.code
      }
      let qs = this.getQueryString()
      if ('code' in qs) {
        return qs.code
      }
      return null
    }
  },
  methods: {
    getIntegrations () {
      this.$appointmentguru.resource('practitioner.integrations').list()
    },
    getQueryString () {
      var pairs = window.location.search.slice(1).split('&')
      var result = {}
      pairs.forEach((pair) => {
        pair = pair.split('=')
        result[pair[0]] = decodeURIComponent(pair[1] || '')
      })
      return JSON.parse(JSON.stringify(result))
    },
    connectToZoom () {
      let data = {
        auth_code: this.oAuthCode
      }
      this.$appointmentguru
        .resource('practitioner.integrations.zoom')
        .id(this.connectReqId)
        .create(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/Zoom/mixins.js